/**
 * Created by piotr.pozniak@thebeaverhead.com on 26/06/2025.
 */

import React from "react";
import classNames from "classnames";
/**
 *
 * @param {string} label
 * @param {function} onClick
 * @param {boolean} [disabled=false]
 * @returns {Element}
 * @constructor
 */
const OrganizationSubscriptionLink = ({ label, onClick, disabled = false }) => {
  return (
    <a
      href={disabled ? null : "#"}
      onClick={onClick}
      className={classNames("a-underlined", {
        "text-muted": disabled,
      })}
    >
      {label}
    </a>
  );
};

export default OrganizationSubscriptionLink;
